import React from 'react';
import { Box } from '@mui/material';

import { COLOR_BLUE, COLOR_OUTLINE, COLOR_TEAL_SURFACE } from '../../../theme';

/** Small pill. `outlined` is used for state such as "Pausad". */
export default function TagChip({ label, outlined = false }: { label: string, outlined?: boolean }) {
    return (
        <Box
            component="span"
            sx={{
                px: 1.25,
                py: 0.2,
                borderRadius: 10,
                fontSize: '0.75rem',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                color: COLOR_BLUE,
                border: `1px solid ${outlined ? COLOR_OUTLINE : 'transparent'}`,
                bgcolor: outlined ? 'transparent' : COLOR_TEAL_SURFACE
            }}
        >
            {label}
        </Box>
    );
}
